<div class="pt-4" *ngIf="!loading; else loadingTpl">
  <canvas
    baseChart
    *ngIf="!tableOnly"
    [datasets]="barChartData"
    [labels]="barChartLabels"
    [options]="barChartOptions"
    [legend]="barChartLegend"
    [type]="'bar'"
  ></canvas>

  <div *ngIf="heading === 'PRODUCTS'" class="input-group mt-3">
    <input
      type="text"
      class="form-control"
      placeholder="{{ 'SEARCH_BAR' | translate }}"
      (keyup)="searchData.next($event)"
      aria-label="Search"
    />
    <div class="input-group-append">
      <span class="input-group-text">
        <i class="fa fa-search" aria-hidden="true"></i>
      </span>
    </div>
  </div>

  <div class="pt-4">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th *ngIf="heading === 'PRODUCTS'" class="col-sortable" (click)="toggleSort('productId')">
              <span translate>PRODUCT_ID</span>
              <ng-container *ngIf="sortKey === 'productId'">
                <i *ngIf="sortAsc" class="fa-solid fa-regular fa-arrow-up-a-z ms-1"></i>
                <i *ngIf="!sortAsc" class="fa-solid fa-regular fa-arrow-down-a-z ms-1"></i>
              </ng-container>
            </th>
            <th class="col-sortable" (click)="toggleSort('key')">
              {{ heading | translate }}
              <ng-container *ngIf="sortKey === 'key'">
                <i *ngIf="sortAsc" class="fa-solid fa-regular fa-arrow-up-a-z ms-1"></i>
                <i *ngIf="!sortAsc" class="fa-solid fa-regular fa-arrow-down-a-z ms-1"></i>
              </ng-container>
            </th>
            <th class="col-sortable text-end" (click)="toggleSort('value')">
              <span translate>ORDER_ANALYTICS_SALES</span>
              <ng-container *ngIf="sortKey === 'value'">
                <i *ngIf="sortAsc" class="fa-solid fa-regular fa-arrow-up-1-9 ms-1"></i>
                <i *ngIf="!sortAsc" class="fa-solid fa-regular fa-arrow-down-1-9 ms-1"></i>
              </ng-container>
            </th>
            <th class="col-sortable text-end" (click)="toggleSort('count')">
              <span translate>QUANTITY</span>
              <ng-container *ngIf="sortKey === 'count'">
                <i *ngIf="sortAsc" class="fa-solid fa-regular fa-arrow-up-1-9 ms-1"></i>
                <i *ngIf="!sortAsc" class="fa-solid fa-regular fa-arrow-down-1-9 ms-1"></i>
              </ng-container>
            </th>
            <th *ngIf="groupBy !== 'orderId'" class="col-sortable text-end" (click)="toggleSort('orderCount')">
              <span translate>ORDERS</span>
              <ng-container *ngIf="sortKey === 'orderCount'">
                <i *ngIf="sortAsc" class="fa-solid fa-regular fa-arrow-up-1-9 ms-1"></i>
                <i *ngIf="!sortAsc" class="fa-solid fa-regular fa-arrow-down-1-9 ms-1"></i>
              </ng-container>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of sortedData">
            <td *ngIf="heading === 'PRODUCTS'" class="align-middle">
              <span *ngIf="!!element.elements[0].productModelId; else productId">{{ element.elements[0].productModelId }}</span>
              <ng-template #productId>
                <span *ngIf="!!element.elements[0].productId">{{ element.elements[0].productId }}</span>
              </ng-template>
            </td>
            <td class="align-middle">
              <a *ngIf="groupBy === 'orderId'" [href]="'orders/' + element.key">{{ element.key }}</a>
              <span *ngIf="groupBy !== 'orderId'">{{ element.key }}</span>
            </td>
            <td class="align-middle text-end">{{ element.value | gungCurrency: '':'code' }}</td>
            <td class="align-middle text-end">{{ element.count }}</td>
            <td *ngIf="groupBy !== 'orderId'" class="align-middle text-end">{{ element.orderCount }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h2 translate>Total</h2>
    <div class="table-responsive">
      <table class="table" style="border: none">
        <thead>
          <tr>
            <th></th>
            <th translate>ORDER_ANALYTICS_SALES</th>
            <th translate>QUANTITY</th>
            <th translate>ORDERS</th>
          </tr>
        </thead>
        <tbody>
          <tr style="border-bottom: 2px solid black">
            <td style="padding: 0 12px 0 24px; text-align: right" translate>TOTAL</td>
            <td class="text-end">{{ summaryTotals.value | gungCurrency: '':'code' }}</td>
            <td class="text-end">{{ summaryTotals.count }}</td>
            <td class="text-end" *ngIf="groupBy !== 'orderId'">{{ summaryTotals.orderCount }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #loadingTpl>
  <div class="text-center dashboard-loading-spinner">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</ng-template>
